export default "__VITE_ASSET__B56Qwd4g__"